# frozen_string_literal: true

module Engine
  module Game
    module G1812
    end
  end
end
